/*
 * Cart icon as a toggle (cart_type = page). From any page the icon opens /cart as usual. On the cart
 * page itself, clicking it again returns the shopper to the page they came from on this site, or to
 * the home page if they landed on /cart directly.
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartPath = root + 'cart';

  function onCartPage() {
    return window.location.pathname.replace(/\/$/, '') === cartPath.replace(/\/$/, '');
  }

  document.addEventListener('click', function (event) {
    if (!onCartPage()) return;
    var link = event.target.closest && event.target.closest('a.action__cart, a[href$="/cart"].header-actions__action');
    if (!link) return;
    event.preventDefault();

    var cameFromSite = false;
    try {
      var ref = new URL(document.referrer);
      cameFromSite = ref.origin === window.location.origin && ref.pathname.replace(/\/$/, '') !== cartPath.replace(/\/$/, '');
    } catch (e) {}

    if (cameFromSite && window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = root;
    }
  });
})();
